<dz-actions-menu *ngIf="supportedFundStatusInteractions?.length">
	<div class="interaction-menu">
		<div *ngIf="showHeader">
			<div
				class="drawer-row bottom-border title d-flex justify-content-between"
				[ngClass]="{
					'drawer-section': !showHeader,
					'bottom-border': !displayStatus
				}"
			>
				<div dcrHTMLKey="FUND_STATUS_INTERACTION_MENU_TITLE">Review Status</div>
				<dz-icon type="times" (click)="closeCallback()" custom-tracking [track-event]="'fund-tag-menu:' + fundData.ticker?.formattedValue + ':close'"></dz-icon>
			</div>
		</div>

		<div class="drawer-section" *ngIf="displayStatus">
			<div class="drawer-row status-row">
				<div>
					<span dcrHTMLKey="FUND_ANALYSIS_CURRENT_STATUS_TOOLTIP" class="tooltip-text tooltip-text-bold">Current Status </span>
					<span dcrHTMLKey="FUND_ANALYSIS_AS_OF_DATE_TOOLTIP" class="tooltip-text">as of: </span>
					<span class="tooltip-text">{{ asOfDate }} </span>
				</div>
				<div
					class="tooltip-status-container"
					[ngClass]="{
						'padding-bottom-8': statusChange,
						'padding-bottom-16': !statusChange,
						'bottom-border': !statusChange && !isSuggestedAddition
					}"
				>
					<img class="icon" [remote-src]="tooltipStatusIconSrc" />
					<span class="tooltip-text" [dcrHTMLKey]="'FUND_ANALYSIS_STATUS_TOOLTIP_' + statusColour"></span>
				</div>

				<ng-container *ngIf="statusChange">
					<div>
						<span dcrHTMLKey="FUND_ANALYSIS_PREVIOUS_STATUS_TOOLTIP" class="tooltip-text tooltip-text-bold">Previous Status </span>
						<span dcrHTMLKey="FUND_ANALYSIS_AS_OF_DATE_TOOLTIP" class="tooltip-text">as of: </span>
						<span class="tooltip-text">{{ asOfDateCompare }} </span>
					</div>
					<div
						class="padding-bottom-16 tooltip-status-container"
						[ngClass]="{
							'bottom-border': !isSuggestedAddition
						}"
					>
						<img class="icon" [remote-src]="tooltipStatusComparisonIconSrc" />
						<span class="tooltip-text" [dcrHTMLKey]="'FUND_ANALYSIS_STATUS_TOOLTIP_' + comparisonStatusColour"> </span>
					</div>
				</ng-container>
			</div>
		</div>

		<ng-container *ngIf="!isSuggestedAddition">
			<div class="bottom-border" [ngClass]="{ 'drawer-section': !showHeader }">
				<div
					class="drawer-row option d-flex"
					custom-tracking
					[track-event]="'fund-status-interaction-menu:' + mode + ':' + fundData.ticker?.formattedValue + ':radio:' + fundData.status.formattedValue"
				>
					<!-- The static option of the current option -->
					<dz-radio [value]="'default'" [name]="'statusInteractionRadio'" [checked]="selectedInteractionId === 'default'" (change)="onRadioClick('default')">
						<img class="interaction-icon" [remote-src]="'iq/status-' + fundData.status.rawValue + '.svg'" />
						<div [dcrHTMLKey]="'FUND_ANALYSIS_STATUS_TOOLTIP_' + fundData.status.rawValue" class="interaction-description"></div>
					</dz-radio>
				</div>
				<div *ngFor="let statusGroup of supportedFundStatusInteractions">
					<div
						*ngFor="let status of statusGroup.interactions"
						class="drawer-row option d-flex"
						custom-tracking
						[track-event]="'fund-status-interaction-menu:' + mode + ':' + fundData.ticker?.formattedValue + ':radio:' + status?.id"
					>
						<dz-radio [value]="status.id" [name]="'statusInteractionRadio'" [checked]="selectedInteractionId === status.id" (change)="onRadioClick(status.id)">
							<img class="interaction-icon" [remote-src]="'iq/' + status.id + '-' + fundData.status.rawValue + '.svg'" />
							<div class="interaction-description">{{ status.description }}</div>
						</dz-radio>
					</div>
				</div>
			</div>
			<div class="drawer-section">
				<div class="drawer-row d-flex justify-content-right small">
					<button
						dz-small-button
						dcrHTMLKey="FUND_STATUS_INTERACTION_MENU_BUTTON"
						(click)="onApply()"
						custom-tracking
						[track-event]="'fund-status-interaction-menu:' + mode + ':' + fundData.ticker?.formattedValue + ':save'"
					>
						Apply
					</button>
				</div>
			</div>
		</ng-container>
	</div>
</dz-actions-menu>
